import processEnv from "../processEnv";

const fetchKoalaOffersQuery = (oqry: any) => {
  console.log("PASSED QUERY DATA: ", oqry);

  return fetch(`https://staging-partner.api.hikoala.co/quotes`, {
    method: "POST",
    referrerPolicy: "no-referrer",
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Headers":
        "Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers",
      "Content-Type": "application/json",
      "Accept-Encoding": "gzip",
      Accept: "application/json",
      "Access-Control-Allow-Methods": "GET,HEAD,OPTIONS,POST,PUT",
      Authorization:
        "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJncm91cCI6IlBBUlRORVIiLCJuYW1lIjoiUGFydG5lciBEZW1vIiwicGFydG5lciI6eyJpZCI6IjU1NzYyMmUxLTUzNjctNGIwOS1hNzVkLWQ5OTZjYTA0OWJhNiIsIm5hbWUiOiJQYXJ0bmVyIERlbW8iLCJjb3VudHJ5SWQiOiJGUiJ9LCJpYXQiOjE2NTkxMDgyNjIsImV4cCI6MTcyMjIyMzQ2Mn0.nz9Lq9mCnreAuZsu599WkiDGkZXrqg65la5bB37zJnk",
    },
    body: JSON.stringify(oqry),
  });
  /*
	return fetch(`https://api.duffel.com/air/partial_offer_requests`, {
		method: 'POST',
        referrerPolicy: 'no-referrer',
		headers: {
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Headers": "Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers",
			'Content-Type': 'application/json',
             "Accept-Encoding":"gzip",
             "Accept": "application/json",
             "Access-Control-Allow-Methods":"GET,HEAD,OPTIONS,POST,PUT",
             "Duffel-Version": "v1" ,
            "Authorization": "Bearer duffel_test_0D60g6XG_fY4RvLUMRtRQN5MaLzAGG2YnXuIWM9qu2p",
		},
	   body: JSON.stringify(bodyP),
	})
	*/
};

export default fetchKoalaOffersQuery;
